import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements OnInit {
  @Input() modalContentHTML: string = ''
  @Input() size: string = 'modal-xl';
  @Input() idModal: string = 'modalCore';
  @Input() classPosition: string = '';
  safeHTML: any

  constructor(private Sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    //Evitar remover etiquetas HTML como <input> y permite eventos JS
    this.safeHTML = this.Sanitizer.bypassSecurityTrustHtml(this.modalContentHTML);
  }
}
